// 剪切图片
function clipImage(position, image, cb) {
	let rectWidth = position.endX - position.startX
	let rectHeight = position.endY - position.startY
	let canvas = document.createElement('canvas')
	canvas.width = rectWidth
	canvas.height = rectHeight
	const ctx = canvas.getContext('2d')
	let img = new Image()
	img.crossOrigin = '*'
	img.crossOrigin = 'anonymous'
	img.src = image
	img.onload = function() {
		ctx.drawImage(img, position.startX, position.startY, rectWidth, rectHeight, 0, 0, rectWidth, rectHeight)
		cb && cb(canvas.toDataURL('image/png'))
	}
}
export { clipImage }
